/** Shared geometries. Tube radii are the real HAKI profiles (see docs/SOURCES.md). */

import { BoxGeometry, CylinderGeometry, SphereGeometry } from "three";

export const G = {
  /** Unit cylinder, scaled per use. */
  cyl: new CylinderGeometry(1, 1, 1, 14),
  /** Ø48.3 standard / ERB tube. */
  tube48: new CylinderGeometry(0.024, 0.024, 1, 14),
  /** Ø34 lattice chord and diagonal. */
  tube34: new CylinderGeometry(0.017, 0.017, 1, 10),
  /** Ø27 ladder stile and rung. */
  tube27: new CylinderGeometry(0.0135, 0.0135, 1, 10),
  /** Ø30 guardrail tube. */
  tube15: new CylinderGeometry(0.015, 0.015, 1, 10),
  collar: new CylinderGeometry(0.034, 0.034, 0.04, 12),
  sleeve: new CylinderGeometry(0.028, 0.028, 0.09, 12),
  plate: new BoxGeometry(0.15, 0.012, 0.15),
  thread: new CylinderGeometry(0.019, 0.019, 1, 10),
  box: new BoxGeometry(1, 1, 1),
  sph: new SphereGeometry(0.055, 12, 10),
  dot: new CylinderGeometry(0.09, 0.09, 0.02, 16),
  gtube: new CylinderGeometry(0.03, 0.03, 1, 8),
  tab: new BoxGeometry(0.12, 0.038, 0.02),
};
